var map = {
	"./INTELLIGENCE_CENTER.png": 808,
	"./LAVATORY.png": 2343,
	"./MEDSTATION.png": 5921,
	"./NUTRITION_UNIT.png": 6180,
	"./WATER_COLLECTOR.png": 3801,
	"./WORKBENCH.png": 7482
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1034;